<template>
    <div class="home">
        <v-btn color="primary" @click="addSurvey" prepend-icon="mdi-plus">
            Agregar nueva encuesta
        </v-btn>
    </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';

const router = useRouter();

function addSurvey() {
    router.push({
        name: 'Survey',
        params: { id: 'new' }
    });
}
</script>

<style lang="scss" scoped>
.home {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
